import { Offcanvas } from "react-bootstrap";
import CameraDetails from "./CameraDetails";
import GondolaDetails from "./GondolaDetails";


const DetailsPanel = (props) => {
    const { isVisible, hide, selectedObject, deploymentId, refetchCameras, refetchGondolas } = props;

    const objType = selectedObject ? selectedObject.objType : "";

    return (
        <Offcanvas show={isVisible} onHide={() => { hide() }} placement="start">

            {objType === "camera" &&
                <>
                    <Offcanvas.Header closeButton>
                        <img src="/sensei-small-logo.jpg" alt="small sensei logo" />
                        <Offcanvas.Title className="text-secondary fs-4 fw-bold">Camera Details</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <CameraDetails cameraCircle={selectedObject} deploymentId={deploymentId} refetchCameras={refetchCameras}/>
                    </Offcanvas.Body>
                </>
            }

            {objType === "gondola" &&
                <>
                    <Offcanvas.Header closeButton>
                        <img src="/sensei-small-logo.jpg" alt="small sensei logo"/>
                        <Offcanvas.Title className="text-secondary fs-4 fw-bold">Gondola Details</Offcanvas.Title>
                    </Offcanvas.Header>
                    <Offcanvas.Body>
                        <GondolaDetails gondolaBox={selectedObject} deploymentId={deploymentId} refetchGondolas={refetchGondolas} hidePanel={hide}/>
                    </Offcanvas.Body>
                </>
            }

        </Offcanvas>
    )
}

export default DetailsPanel;
